import { render, staticRenderFns } from "./ContractsLegacy.vue?vue&type=template&id=7639b7ea"
import script from "./ContractsLegacy.vue?vue&type=script&lang=js"
export * from "./ContractsLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports